<template>
  <section class="order-document-download-modal">
    <v-btn
      v-if="document.content.url"
      icon
      color="primary"
      title="Download Documento"
      @click.prevent.stop="openModal()"
    >
      <v-icon size="15">
        file_download
      </v-icon>      
    </v-btn>
    <v-dialog
      v-if="modal.show"
      v-model="modal.show"
      width="300"
      persistent  
      @keydown.esc="closeModal"
    >     
      <v-card class="mb-0">         
        <v-card-text class="app-card-content text-center pt-6">
          <!-- <v-btn
            icon      
            title="fechar modal"
            @click.prevent.stop="closeModal()"
            v-if="document.content.url"
          >
            <v-icon size="15">close</v-icon>
          </v-btn> -->

          <p class="mb-0">
            Baixando {{ document.document_type.name }} ...
          </p>
        </v-card-text>        
      </v-card>    
    </v-dialog>
  </section>
</template>

<script>
  export default {
    name: 'OrderDocumentDownloadButton',
    props: {
      order: {
        type: Object,
        required: true
      },
      document: {
        type: Object,
        required: true
      },
    },  
    data: () => ({
      modal: {
        show: false
      },
    }),
    methods: {
      closeModal() {
        this.modal.show = false;
      },

      openModal() {      
        this.modal.show = true;
        this.download();
      },

      download() {
        window.open(this.document.content.url, '_blank');
        this.closeModal();
      }
    },
  }
</script>